/**
 * Escada de toques do follow-up proativo da Mia V3: cada caso (pedido parado e
 * conversa sem carrinho) tem até 3 tempos em minutos, contados a partir do
 * momento em que o cliente parou de responder. O ciclo de venda de delivery é
 * curto — a escada padrão inteira cabe em menos de meia hora.
 */
export const TOQUES_PADRAO_CARRINHO = [2, 8, 25];
export const TOQUES_PADRAO_DESCOBERTA = [1, 10];
export const MAXIMO_DE_TOQUES = 3;

/**
 * Mantém só minutos inteiros de 1 a 60 em ordem estritamente crescente, até o
 * máximo de toques; sem sobrevivente, devolve a escada padrão recebida.
 */
export function saneieToquesDeFollowup(valores: any, padrao: number[]): number[] {
  const saneados: number[] = [];
  for (const valor of Array.isArray(valores) ? valores : []) {
    const minutos = Number(valor);
    if (!Number.isInteger(minutos) || minutos < 1 || minutos > 60) continue;
    if (saneados.length && minutos <= saneados[saneados.length - 1]) continue;
    saneados.push(minutos);
    if (saneados.length === MAXIMO_DE_TOQUES) break;
  }
  return saneados.length ? saneados : [...padrao];
}

/**
 * Config antiga (lembrete único): o valor salvo vira o 1º toque e os demais
 * seguem o ritmo da escada padrão, grudando no teto de 60 quando estourariam.
 */
export function deriveEscadaDoLembrete(primeiroToque: number, escadaPadrao: number[]): number[] {
  const escada = [primeiroToque];
  for (let indice = 1; indice < escadaPadrao.length; indice++) {
    const minutos = Math.min(60, primeiroToque + escadaPadrao[indice] - escadaPadrao[0]);
    if (minutos > escada[escada.length - 1]) escada.push(minutos);
  }
  return escada;
}
